import { useEffect } from "react";
import { observer } from "mobx-react-lite";

import { useAuthStore } from "@/features/auth";
import { useCompanyStore } from "../hooks";
import CompanySetupWizard from "../components/CompanySetupWizard";

const CompanySetupPage = observer(() => {
  const { user } = useAuthStore();
  const { fetchCompany, company, setCompany, syncDraftOwner } =
    useCompanyStore();

  const userId = user?.userId ?? user?.id ?? user?._id ?? user?.email ?? null;
  const companyId = user?.companyId ?? null;

  useEffect(() => {
    syncDraftOwner(userId);
  }, [syncDraftOwner, userId]);

  useEffect(() => {
    if (!companyId) {
      setCompany(null);
      return;
    }
    fetchCompany({ companyId, force: true });
  }, [companyId, fetchCompany, setCompany]);

  const hasCompanyData = Boolean(companyId);
  const containerClassName = hasCompanyData
    ? "flex w-full"
    : "flex w-full items-center justify-center py-6";

  return (
    <div className={containerClassName}>
      <CompanySetupWizard
        compact={!hasCompanyData}
        companyId={companyId}
        companyData={company}
      />
    </div>
  );
});

export default CompanySetupPage;
